<template>
    <div>
      <div style="margin-bottom: 1.5rem;" id='usagu' v-if='onlinestate == "pc"'>
        <span style="color: #09666E;font-size: 16px;">{{islang=='eng' || islang=='dubai'?'Select Region: ':'選擇地區：'}}</span>
         <a-select v-model='input' style="width: 11rem" @change='seachand'>
           <a-select-option v-for='(v,i) in list' :key='i+"2112"' :value="i">{{islang=='big5'?v.name:v.name_en}}</a-select-option>
         </a-select>
      </div>
      <div style="margin-bottom: 1.5rem;position: relative;" id='usagu' v-else>
        <span style="color: #000;font-size: 16px;z-index: 90;position: absolute;line-height: 41px;left: 5px;">{{$lang.xzdq}}</span>
         <a-select v-model='input' style="width: 100%" @change='seachand' id='is_right'>
           <a-select-option v-for='(v,i) in list' :key='i+"2112"' :value="i">{{islang=='big5'?v.name:v.name_en}}</a-select-option>
         </a-select>
      </div>
    </div>
</template>

<script>
  export default{
    props:['seach'],
    data(){
      return{
        onlinestate:sessionStorage['onlinestate'],
        islang: window.localStorage.guanwanglang,
        list:[
          {name:'美股',url:'/ussecurities_introduction',name_en:this.$lang.m_g},
          // {name:'滬港深通',url:'/stockconnect_introduction',name_en:'Shanghai-HK Stocks'},
          {name:'新加坡股',url:'/sgsecurities_introduction',name_en:this.$lang.xjp_g},
          {name:'馬來西亞股',url:'/mysecurities_introduction',name_en:this.$lang.mlxyg},
          {name:'泰股',url:'/thsecurities_introduction',name_en:this.$lang.tgg},
          {name:'菲律賓股',url:'/phsecurities_introduction',name_en:this.$lang.flbg},
          {name:'印尼股',url:'/idsecurities_introduction',name_en:this.$lang.yng},
          {name:'澳洲股',url:'/ausecurities_introduction',name_en:this.$lang.azg},
          {name:'日股',url:'/jpsecurities_introduction',name_en:this.$lang.rg},
          {name:'台股',url:'/twsecurities_introduction',name_en:this.$lang.tg},
          {name:'德股',url:'/gesecurities_introduction',name_en:this.$lang.d_g},
          ],
        input:0
      }
    },
    watch:{
      seach:{
        immediate:true,
        handler(ev){
          if(ev){
            this.list.map((val,ind)=>{
              if(val.name==this.seach){
                 this.input= ind
              }
            })
          }
        }
      }
    },
    methods:{
      seachand(ev){
        this.list.map((val,i)=>{
          if(i == this.input){
            this.$router.push(val.url)
          }
        })
      }
    }
  }
</script>

<style>
  .ant-select-dropdown-menu{
    padding: 0 !important;
  }
  #usagu .ant-select-selection--single {
      /* height: 2rem; */
      border-radius: 0;
      border-color: #333;
      font-size: 16px;
      }
   #usagu .ant-select-selection__rendered{
      /* line-height: 2rem; */
    }
    #is_right .ant-select-selection-selected-value {
        float: right;
        position: relative;
        right: 5px;
    }

    #usagu .ant-select-focused .ant-select-selection, .ant-select-selection:active, .ant-select-selection:focus {
        -webkit-box-shadow: 0 0 0 0 #000;
        box-shadow: 0 0 0 0 #000;
    }
</style>



// WEBPACK FOOTER //
// src/components/login/seachlange.vue